import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import routes from "./routes";

const RouteRenderer = () => {
  return (
    <Routes>
      {routes.map((route, index) => {
        if (route.isProtected) {
          return (
            <Route
              key={index}
              path={route.path}
              element={<PrivateRoute>{route.element}</PrivateRoute>}
            />
          );
        } else {
          return (
            <Route key={index} path={route.path} element={route.element} />
          );
        }
      })}
    </Routes>
  );
};

export default RouteRenderer;